// **********************************************************
// Wishlist button
// **********************************************************

const toggleWhishListText = (toggle, elem) => {
  elem.querySelector('.added').classList.toggle('is-active', !toggle);
  elem.querySelector('.removed').classList.toggle('is-active', toggle);
}

const toggleWhishListModal = (toggle, elem) => {
  elem.classList.toggle('is-active', toggle);
}

const openWhishListModal = (wishlistModal, toggle) => {
  toggleWhishListModal(true, wishlistModal);
  setTimeout(() => toggleWhishListModal(false, wishlistModal), 2000);
  toggleWhishListText(toggle, wishlistModal);
}

attachEvent('.wishlist-button', 'click', (ev) => {
  const parentElem = ev.target.closest('.wishlist-button');
  const superParent = ev.target.closest('.single-product');
  if (superParent) {
    const wishlistModal = superParent.querySelector('.wishlist-modal');
    const isAdded = parentElem.classList.contains('is-active');
    openWhishListModal(wishlistModal, isAdded);
  }
  parentElem.classList.toggle('is-active');
});
